/**
 * Announcement Bar Slider
 * Handles multiple announcement slides with auto-scroll and manual navigation
 */
class AnnouncementBarSlider {
    constructor(container) {
        this.container = container;
        this.slider = container.querySelector('#announcement-slider');
        this.prevBtn = container.querySelector('#announcement-prev');
        this.nextBtn = container.querySelector('#announcement-next');

        if (!this.slider) return;

        this.currentSlide = 0;
        this.totalSlides = parseInt(container.dataset.slides) || 1;
        this.autoScroll = container.dataset.autoScroll === 'true';
        this.scrollSpeed = parseInt(container.dataset.scrollSpeed) || 5000;
        this.autoScrollInterval = null;
        this.isTransitioning = false;

        // Only initialize if we have multiple slides
        if (this.totalSlides > 1) {
            this.init();
        }
    }

    init() {
        this.bindEvents();
        this.startAutoScroll();

        // Set initial state
        this.goToSlide(0);
    }

    goToSlide(slideIndex) {
        if (this.isTransitioning) return;

        this.isTransitioning = true;
        this.currentSlide = slideIndex;

        const translateX = -(this.currentSlide * 100);
        this.slider.style.transform = `translateX(${translateX}%)`;

        // Reset transition flag after animation
        setTimeout(() => {
            this.isTransitioning = false;
        }, 300);
    }

    bindEvents() {
        // Navigation buttons
        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => {
                this.stopAutoScroll();
                this.prevSlide();
                this.startAutoScroll();
            });
        }

        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => {
                this.stopAutoScroll();
                this.nextSlide();
                this.startAutoScroll();
            });
        }

        // Pause on hover
        this.container.addEventListener('mouseenter', () => this.stopAutoScroll());
        this.container.addEventListener('mouseleave', () => this.startAutoScroll());

        // Keyboard navigation
        this.container.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
                this.stopAutoScroll();
                this.prevSlide();
                this.startAutoScroll();
            } else if (e.key === 'ArrowRight') {
                this.stopAutoScroll();
                this.nextSlide();
                this.startAutoScroll();
            }
        });

        // Touch/swipe support
        this.addSwipeSupport();
    }

    addSwipeSupport() {
        let startX = 0;
        let startY = 0;
        let endX = 0;
        let endY = 0;

        this.slider.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        });

        this.slider.addEventListener('touchend', (e) => {
            endX = e.changedTouches[0].clientX;
            endY = e.changedTouches[0].clientY;

            const deltaX = startX - endX;
            const deltaY = startY - endY;

            // Only handle horizontal swipes
            if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
                this.stopAutoScroll();

                if (deltaX > 0) {
                    this.nextSlide();
                } else {
                    this.prevSlide();
                }

                this.startAutoScroll();
            }
        });
    }

    nextSlide() {
        const nextIndex = (this.currentSlide + 1) % this.totalSlides;
        this.goToSlide(nextIndex);
    }

    prevSlide() {
        const prevIndex = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
        this.goToSlide(prevIndex);
    }

    startAutoScroll() {
        if (this.autoScroll && this.totalSlides > 1) {
            this.autoScrollInterval = setInterval(() => {
                this.nextSlide();
            }, this.scrollSpeed);
        }
    }

    stopAutoScroll() {
        if (this.autoScrollInterval) {
            clearInterval(this.autoScrollInterval);
            this.autoScrollInterval = null;
        }
    }

    destroy() {
        this.stopAutoScroll();
        // Remove event listeners if needed
    }
}

// Initialize announcement bar sliders when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
    const announcementBars = document.querySelectorAll('.announcement-bar');

    announcementBars.forEach(bar => {
        new AnnouncementBarSlider(bar);
    });
});

// Handle theme editor updates
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
        const announcementBar = event.target.querySelector('.announcement-bar');
        if (announcementBar) {
            new AnnouncementBarSlider(announcementBar);
        }
    });
}
